import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";

export default function DigestToggle() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user?.role !== "admin") return null;

  const toggle = async (checked) => {
    setBusy(true);
    try {
      const { data } = await api.put("/auth/me/preferences", { digest_opt_in: checked });
      setUser(data);
      toast.success(checked ? "You'll receive the Friday digest" : "Friday digest turned off for you");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <label className="flex items-center justify-between gap-2 text-xs text-muted-foreground mb-3 cursor-pointer" data-testid="digest-toggle-label">
      <span>Friday digest email</span>
      <Switch data-testid="digest-toggle" checked={user.digest_opt_in !== false} disabled={busy} onCheckedChange={toggle} />
    </label>
  );
}
